var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-folder_svg__a_".concat(unique),
    d: "M0 20h20V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.678 15.498a.504.504 0 01-.502.502H2.502A.503.503 0 012 15.498V3.502C2 3.225 2.225 3 2.502 3h5.002c.172 0 .33.087.422.232l.347.548L9.74 6.106c.004.008.011.013.016.021l.43.68h6.99c.276 0 .502.225.502.502v8.189zM14.653 3.915a.2.2 0 01.199.2v1.493a.2.2 0 01-.199.199H11.01a.499.499 0 01-.415-.224L9.542 3.915h5.111zm2.523 1.892h-1.364c.012-.067.04-.128.04-.199V4.115c0-.661-.538-1.2-1.199-1.2H8.909l-.135-.214A1.493 1.493 0 007.504 2H2.502C1.674 2 1 2.674 1 3.502v11.996C1 16.326 1.674 17 2.502 17h14.674c.828 0 1.502-.674 1.502-1.502V7.309c0-.828-.674-1.502-1.502-1.502z",
    id: "icon-folder_svg__b_".concat(unique)
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-folder_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-folder_svg__b_".concat(unique)
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#icon-folder_svg__b_".concat(unique)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    mask: "url(#icon-folder_svg__c)",
    d: "M0 0h20v20H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/assets/icon-folder.4d6925f0.svg";
export { ForwardRef as ReactComponent };